// src/api/auth.js
import client from './client.js';

export const authAPI = {
  register: (data) => client.post('/auth/register', data),
  login: (data) => client.post('/auth/login', data),
  logout: () => client.post('/auth/logout'),
  refresh: (refreshToken) => client.post('/auth/refresh', { refresh_token: refreshToken }),
  verifyEmail: (data) => client.post('/auth/verify-email', data),
  requestPasswordReset: (email) => client.post('/auth/request-password-reset', { email }),
  resetPassword: (data) => client.post('/auth/reset-password', data),
  getProfile: () => client.get('/auth/profile'),
  updateProfile: (data) => client.put('/auth/profile', data),
  changePassword: (data) => client.post('/auth/change-password', data),
};